import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/useAuth';
import { useAnalytics } from '../../hooks/useAnalytics';

export default function GoogleCallback() {
  const navigate               = useNavigate();
  const [searchParams]         = useSearchParams();
  const { login }              = useAuth();
  const { conversion, track }  = useAnalytics();
  const [status, setStatus]    = useState('processing');

  useEffect(() => {
    const token     = searchParams.get('token');
    const error     = searchParams.get('error');
    const isNewUser = searchParams.get('new') === 'true'; // backend sets ?new=true on first signup

    if (error || !token) {
      setStatus('error');
      if (error === 'admin_not_allowed') {
        setTimeout(() => navigate('/auth?error=admin_not_allowed'), 2500);
      } else {
        setTimeout(() => navigate('/auth?error=google_failed'), 2500);
      }
      return;
    }

    // login() decodes the JWT and returns the merged user object
    const user = login(token);

    if (user) {
      // Fire signup conversion only for new accounts
      // If your backend doesn't send ?new=true, you can also check
      // if createdAt is within the last 60 seconds as a fallback
      const justCreated = isNewUser || isNewAccount(user);
      if (justCreated) {
        conversion.signup(user.userId);
      }

      // Always track the successful login as a page event
      track.pageView('/auth/google/success', 'Google Sign In');
    }

    navigate('/home', { replace: true });
  }, []);

  if (status === 'error') {
  const isAdminError = searchParams.get('error') === 'admin_not_allowed';

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
      style={{ background: 'linear-gradient(135deg, #0a1f15 0%, #0f2d1e 100%)' }}>
      <div className="w-16 h-16 rounded-2xl bg-red-500/15 flex items-center justify-center mb-5">
        <i className={`${isAdminError ? 'ri-shield-keyhole-line' : 'ri-error-warning-line'} text-red-400 text-3xl`} />
      </div>
      <p className="text-white font-semibold text-lg mb-2">
        {isAdminError ? 'Admin account detected' : 'Google sign-in failed'}
      </p>
      <p className="text-white/40 text-sm">
        {isAdminError
          ? 'Please use the admin portal to sign in'
          : 'Redirecting you back…'}
      </p>
    </div>
  );
}

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
      style={{ background: 'linear-gradient(135deg, #0a1f15 0%, #0f2d1e 100%)' }}>
      <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-5"
        style={{ background: 'linear-gradient(135deg, #059669, #34d399)', boxShadow: '0 8px 24px rgba(52,211,153,0.3)' }}>
        <div className="w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin" />
      </div>
      <p className="text-white font-semibold text-lg mb-1">Signing you in…</p>
      <p className="text-white/40 text-sm">Just a moment</p>
    </div>
  );
}

// ── Fallback: treat as new if account was created in the last 60s ──
function isNewAccount(user) {
  if (!user?.createdAt) return false;
  return Date.now() - new Date(user.createdAt).getTime() < 60_000;
}
